import {Component, OnInit} from '@angular/core';
import {BmBillingAreaBaseComponent} from '../bm-billing-area-base.component';


@Component({
    selector: 'bm-billing-area-side',
    templateUrl: 'bm-billing-area-side.component.html',
    standalone: false
})
export class BmBillingAreaSideComponent extends BmBillingAreaBaseComponent implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
